import { useTitle } from '@easyvaas/react-hooks';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import useReachBottom from 'src/hooks/useReachBottom';
import EmptyPlaceholder from '../../components/EmptyPlaceholder';
import { fetchHistory } from '../../services';
import styles from './index.module.scss';
const History = () => {
  useTitle('历史记录');
  const [data, setData] = useState<ImageV3API.HistoryItem[]>();
  const [loading, setLoading] = useState<boolean>(false);
  const next = useRef(0);
  const fetch = useCallback(async () => {
    try {
      if (loading || next.current < 0) return;
      setLoading(true);
      const res = await fetchHistory({ count: 20, start: next.current });
      setData(v => [...(v || []), ...res.list]);
      next.current = res.next;
      setLoading(false);
    } catch ({ message }: any) {
      setLoading(false);
    }
  }, [loading]);

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useReachBottom(fetch);
  if (!data) return null;
  if (data.length === 0) return <EmptyPlaceholder className={styles.empty} />;
  return (
    <div className={styles.container}>
      {data.map((v, i) => (
        <div className={styles.item} key={i}>
          <div className={styles.title}>{v.desc}</div>
          <div className={styles.time}>{v.createAt}</div>
        </div>
      ))}
    </div>
  );
};

export default History;
